import React from "react";

import { DisplayCarouselBlock } from "@reactivated";

import { MediaChooserBlock } from "@thelabnyc/thelabui/src/components/MediaChooserBlock";

import { Carousel } from "../Carousel";
import { Clickable } from "../Clickables";
import { Svg } from "../Svg";
import { ThemedModule } from "../ThemedModule";

import styles from "./display-carousel.module.scss";

export const DisplayCarousel = ({ value }: { value: DisplayCarouselBlock }) => {
    return (
        <ThemedModule theme={value.module_theme}>
            <Carousel
                containerProps={{
                    className: styles.root,
                }}
                scrollContainerProps={{ className: styles.scroller }}
                label={value.label ?? "unlabeled carousel"}
                advanceBy="page"
                loop={false}
                controls={false}
            >
                {value.cards?.map(({ value: card, id }) => (
                    <Clickable
                        key={id}
                        className={styles.card}
                        href={card.link?.url ?? ""}
                    >
                        {card.media && <MediaChooserBlock value={card.media} />}
                        <span className={styles.foreground}>
                            <span>{card.title}</span>
                            <span className={styles.icon}>
                                <Svg name="video/play" />
                            </span>
                        </span>
                    </Clickable>
                ))}
            </Carousel>
        </ThemedModule>
    );
};
